import { Modal, Text, Button, Stack, Group } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setActiveModal, setResultMetadata } from "../../store";

type ConfidenceLevel =
  | "very_confident"
  | "somewhat_confident"
  | "not_confident";

interface ConfidenceModalProps {
  onSubmit: (confidenceLevel: ConfidenceLevel) => void;
}

export const ConfidenceModal = ({ onSubmit }: ConfidenceModalProps) => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(
    (state) => state.oos.activeModal === "confidence",
  );
  const resultMetadata = useAppSelector((state) => state.oos.resultMetadata);

  const handleBack = () => {
    dispatch(
      setResultMetadata({
        ...resultMetadata,
        confidence_modal_returned_to_edit: true,
      }),
    );
    dispatch(setActiveModal(null));
  };

  const handleConfidenceSelect = (level: ConfidenceLevel) => {
    dispatch(setActiveModal(null));
    onSubmit(level);
  };

  return (
    <Modal
      opened={isOpen}
      onClose={handleBack}
      title={<Text fw={600}>How Confident Are You?</Text>}
      centered
      withinPortal={false}
      zIndex={10001}
    >
      <Stack gap="md">
        <Button
          fullWidth
          size="md"
          onClick={() => handleConfidenceSelect("very_confident")}
        >
          Very Confident
        </Button>
        <Button
          fullWidth
          size="md"
          variant="light"
          onClick={() => handleConfidenceSelect("somewhat_confident")}
        >
          Somewhat Confident
        </Button>
        <Button
          fullWidth
          size="md"
          variant="outline"
          onClick={() => handleConfidenceSelect("not_confident")}
        >
          Not Confident
        </Button>
        <Group justify="center" mt="xs">
          <Button variant="subtle" color="gray" onClick={handleBack}>
            Back
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};
